import { useState, useEffect } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputTextArea from "../../helpers/InputTextArea";
import InputUploader from "../../helpers/InputUploader";


function SupportView(props)
{


    const [row, setRow] = useState({
        id: props.row.id,
        temat:  props.row.temat,
        tresc: props.row.tresc,
        numer: props.row.numer,
        dialog: props.row.dialog,
        stan: props.row.stan,
        pliki: props.row.pliki,
     
    });

    const [errTab, setErrTab] = useState([]);  //z info od serwera..


    const valChangeListener = (filedName, val, correct, msg) => {

        if(filedName == 'temat') return;
        if(filedName == 'tresc') return;

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }  

    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


    const saveData = () => {


      
 
        props.mainView.setProgress(-2);

        var req =  {
            id: row.id,
            dialog: row.dialog,
        }


        fetch( Config.url + '/rest_v1,support_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                  
                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Zgłoszenie zostało zaktualizowane" , "ok" , null);                                              
                       props.back();
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }


    var stan = "";
    if(row.stan == '2') stan = "Rozwiązane";
    if(row.stan == '3') stan = "W trakcie realizacji";
    if(row.stan == '1') stan = "Przyjęte";


    return (
      <div className="view_content">
             <h1> {stan} / {row.numer} / {row.temat}</h1>
        
                
            <form className="eForm bg_center">


               
 

                    <div className="form_control">
                            <div className="fieldName">Treść*</div>
                            <InputTextArea   userData={props.userData} value={row.tresc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="tresc" placeholder={"Treść: Mam problem z... "} className=' w300 ' req='1' firstUp="1" />
                    </div>



                    
                    <div className="form_split"></div>


                    <div className="form_control">
                            <div className="fieldName">Chat ze wsparciem / Więcej informacji*</div>
                            <InputTextArea   userData={props.userData} value={row.dialog} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="dialog" placeholder={"Chat: ... "} className=' w400 h200' req='1' firstUp="1" />
                    </div>


                    <div className="form_split"></div>
                    <div className="form_control">
                        Załączniki: <br/><br/>
                        {
                            row.pliki.map( (item, ix) => {


                                    return (
                                            <span>                                               
                                                <img className="w100" src={ "data:image/jpeg;base64, " + item.b64} />
                                            </span>                                       
                                    )

                            } )
                        }
                    </div>

                    <div className="form_split"></div>

                    <div className="form_btn">
                            <div className="btn" onClick={saveData}>zapisz</div>
                            &nbsp;&nbsp;
                            <div className="btn" onClick={props.back}    > anuluj</div>
                    </div>

            </form>


        </div>
    );
}


export default SupportView;
